import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@15.1.6_@babel+core@7.26.9_@opentelemetry+api@1.7.0_@playwright+test@1.50.1_react-dom@19._vi4npdtqupctr2qkjalmzk5a6a/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@15.1.6_@babel+core@7.26.9_@opentelemetry+api@1.7.0_@playwright+test@1.50.1_react-dom@19._vi4npdtqupctr2qkjalmzk5a6a/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/Benefits/Benefits.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/FAQ/FAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ItemScroll"] */ "/opt/build/repo/src/components/Idea/ItemScroll.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/Projects/Projects.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/Section/SectionTitle.tsx");
